import OdsLookup from './ods-lookup';

export default OdsLookup;
